export const ID_MANDATORY = "MANDATORY";
export const ID_LICENSEES = "LICENSEE";